import React from 'react'

import { ZariContext } from '_zari/context'

import { Modal, Table, Button } from '_zari/core'

import * as InventarioService from 'services/inventario.service'

const DetallePaseKardexModal = ({ show, handleClose, idOrdenCompra }) => {
  const __zariContext = React.useContext(ZariContext)

  const [filas, setFilas] = React.useState([])

  React.useEffect(() => {
    InventarioService.obtenerxIdOrdenCompraAsInfoDetalle(idOrdenCompra)
      .then(({ data }) => {
        if (data) {
          setFilas(data)
        }
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
  }, [__zariContext, idOrdenCompra])

  return (
    <Modal show={show} size='xl'>
      <Modal.Header>
        <Modal.Title>Detalle Pase Kardex</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          filas={filas}
          containerId='detalles-pasekardex-ordenescompra'
          headRows={[
            { label: 'FECHA' },
            { label: 'SERIE DOC' },
            { label: 'NUM DOC' },
            { label: 'TITULO' },
            { label: 'PRODUCTO' },
            { label: 'U. MED' },
            { label: 'CANTIDAD' },
            { label: 'PRECIO' },
            { label: 'TOTAL' }
          ]}
          maxRowsShown={10}
          rowTemplate={(row, k) => (
            <Table.Row key={k}>
              <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell>{row.serieDocumento || '--'}</Table.Cell>
              <Table.Cell>{row.numeroDocumento || '--'}</Table.Cell>
              <Table.Cell>{row.titulo || '--'}</Table.Cell>
              <Table.Cell>{row.producto || '--'}</Table.Cell>
              <Table.Cell>{row.unidadMedida || '--'}</Table.Cell>
              <Table.Cell>{row.cantidad || '--'}</Table.Cell>
              <Table.Cell>{row.precio || '--'}</Table.Cell>
              <Table.Cell>{row.subTotal || '--'}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button outline tiny color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(DetallePaseKardexModal)
